import { InputBase } from './input-base.class';

export class CheckboxInput extends InputBase<string> {
  controlType = 'checkbox';
  options: { key: string; value: string; translate?: boolean }[] = [];

  constructor(options = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}
